import api from './api';

export const getProducts = async (options = {}) => {
  try {
    const params = {};
    if (typeof options.shownInHome !== 'undefined') params.shownInHome = options.shownInHome;
    if (typeof options.shownInFanout !== 'undefined') params.shownInFanout = options.shownInFanout;
    if (options.extraParams) Object.assign(params, options.extraParams);
    const response = await api.get('/products', { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getProduct = async (id) => {
  try {
    const response = await api.get(`/products/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const createProduct = async (productData) => {
  try {
    const response = await api.post('/products', productData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateProduct = async (id, productData) => {
  try {
    const response = await api.put(`/products/${id}`, productData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteProduct = async (id) => {
  try {
    const response = await api.delete(`/products/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
